import { useRef, useState, useEffect, useMemo } from 'react'
import { debounce } from 'lodash'

function calculateDimensions(ref) {
  return ref.current
    ? ref.current.getBoundingClientRect()
    : { width: 0, height: 0 }
}

export const useDimensions = () => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })
  const dimensionsRef = useRef()

  const handleLayout = useMemo(
    () =>
      debounce(
        () => {
          const { width, height } = calculateDimensions(dimensionsRef)
          setDimensions({ width, height })
        },
        50,
        { trailing: true }
      ),
    []
  )

  const { width, height } = calculateDimensions(dimensionsRef)
  useEffect(() => {
    setDimensions({ width, height })
  }, [height, width])

  useEffect(() => {
    window.addEventListener('resize', handleLayout)
    return () => {
      window.removeEventListener('resize', handleLayout)
    }
  }, [handleLayout])

  return {
    width: dimensions.width,
    height: dimensions.height,
    dimensionsRef,
    forceUpdate: handleLayout
  }
}
